import { Clock, Lock, ArrowLeft } from 'lucide-react';

/**
 * États vides du rapport cabinet, dans la charte bordeaux/ivoire.
 * Trois variantes : loading, plan insuffisant, rapport non disponible.
 */

function CabinetShell({ children }) {
  return (
    <div
      className="min-h-screen bg-cabinet-cream font-manrope text-cabinet-ink antialiased flex items-center justify-center p-8"
      data-testid="cabinet-empty-shell"
    >
      <div className="w-full max-w-2xl">{children}</div>
    </div>
  );
}

export function ReportLoadingState() {
  return (
    <CabinetShell>
      <div className="text-center" data-testid="report-loading">
        <div className="font-playfair text-[12px] text-cabinet-bordeaux tracking-[0.3em] uppercase mb-6">Cabinet Benchory</div>
        <div className="w-8 h-8 border-2 border-cabinet-border border-t-cabinet-bordeaux rounded-full animate-spin mx-auto" />
        <div className="mt-6 text-[12px] text-cabinet-ink-secondary tracking-wide">Préparation de votre rapport mensuel…</div>
      </div>
    </CabinetShell>
  );
}

export function UpgradeRequiredState({ onExit }) {
  return (
    <CabinetShell>
      <div className="bg-cabinet-paper border border-cabinet-border shadow-sm p-12 text-center" data-testid="upgrade-required">
        <Lock size={28} className="text-cabinet-bordeaux mx-auto mb-6" />
        <div className="font-playfair text-[12px] text-cabinet-bordeaux tracking-[0.3em] uppercase mb-4">Cabinet Benchory</div>
        <h1 className="font-playfair text-[26px] text-cabinet-ink leading-tight mb-5">
          Le rapport de cabinet est réservé aux offres Pilotage et Premium
        </h1>
        <p className="text-[14px] text-cabinet-ink-secondary leading-[1.7] mb-8 max-w-xl mx-auto">
          Le rapport mensuel signé par le Cabinet Benchory est l'argument différenciant de nos offres supérieures. Il offre une analyse stratégique senior, un plan d'action chiffré et un accompagnement personnalisé chaque mois.
        </p>
        <button
          onClick={onExit}
          data-testid="upgrade-back-btn"
          className="inline-flex items-center gap-2 text-[11px] text-cabinet-ink-secondary hover:text-cabinet-bordeaux uppercase tracking-[0.2em] transition"
        >
          <ArrowLeft size={13} /> Retour au portail
        </button>
      </div>
    </CabinetShell>
  );
}

export function ReportNotFoundState({ period, onExit }) {
  return (
    <CabinetShell>
      <div className="bg-cabinet-paper border border-cabinet-border shadow-sm p-12 text-center" data-testid="report-not-found">
        <Clock size={28} className="text-cabinet-gold mx-auto mb-6" />
        <div className="font-playfair text-[12px] text-cabinet-bordeaux tracking-[0.3em] uppercase mb-4">Cabinet Benchory</div>
        <h1 className="font-playfair text-[26px] text-cabinet-ink leading-tight mb-5">
          {period ? 'Rapport non disponible pour cette période' : 'Votre prochain rapport arrive'}
        </h1>
        <p className="text-[14px] text-cabinet-ink-secondary leading-[1.7] mb-3 max-w-xl mx-auto">
          Votre rapport de pilotage mensuel sera disponible le 8 du mois suivant la clôture de la période.
        </p>
        <p className="font-playfair italic text-[13px] text-cabinet-ink-soft leading-[1.7] mb-8 max-w-xl mx-auto">
          Notre équipe d'analyse traite vos saisies entre le 6 et le 8 de chaque mois pour vous livrer un rapport rigoureux et personnalisé.
        </p>
        <button
          onClick={onExit}
          data-testid="not-found-back-btn"
          className="inline-flex items-center gap-2 text-[11px] text-cabinet-ink-secondary hover:text-cabinet-bordeaux uppercase tracking-[0.2em] transition"
        >
          <ArrowLeft size={13} /> Retour au portail
        </button>
      </div>
    </CabinetShell>
  );
}
